export type Tomo = {
  number: string
  title: string
  subtitle: string
  body: string
  outcome: string
  image: string
  alt: string
  featured?: boolean
  featuredLabel?: string
}

export const tomos: Tomo[] = [
  {
    number: 'Tomo 1',
    title: 'El ADN del Evento',
    subtitle:
      'Concepto, storytelling y diseño de experiencias para quinceaños 2026',
    body: 'Cómo leer a una quinceañera de la generación Z antes de que abra la boca y convertir eso en un concepto que nadie regatea. Incluye el Método del Triángulo Narrativo, la Entrevista Diagnóstico de 25 preguntas, el moodboard que vende la idea sin una sola foto real y el guion del evento en tres actos: el hook, el clímax y el after-glow.',
    outcome: 'Dejas de ofrecer decoración y empiezas a vender una visión.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/4616ac04-b09f-422d-90a4-b6946aea4c1e.jpg',
    alt: 'Mockup de la portada vertical del Tomo 1, El ADN del Evento, en color tinta con filetes dorados.',
  },
  {
    number: 'Tomo 2',
    title: 'Ingeniería Financiera',
    subtitle: 'Presupuestos, márgenes de ganancia y negociación',
    body: 'La parte donde la mayoría pierde plata sin darse cuenta. La Regla 40-30-20-10 para equilibrar cualquier presupuesto, el Costo por Invitado Real (con los gastos ocultos que nadie te menciona), la Tarifa de Planner, el Fondo de Contingencia del 5% y cómo elegir entre fee fijo y porcentaje según el evento.',
    outcome:
      'Dejas de pagar los errores de los proveedores con tu propia ganancia.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/10bc1dad-9d45-492f-8f0e-80ee19ca3158.jpg',
    alt: 'Mockup de la portada vertical del Tomo 2, Ingeniería Financiera, en marfil con marco dorado.',
  },
  {
    number: 'Tomo 3',
    title: 'Logística y Producción',
    subtitle:
      'El cronograma maestro, el minuto a minuto y la gestión del staff',
    body: 'La arquitectura operativa de las 24 horas que más importan. El Ingreso Escalonado de proveedores (por qué citarlos a todos a la misma hora te arruina el montaje), el Minuto a Minuto Técnico con cues de luz y audio, la gestión de los tiempos muertos, los tres roles del equipo y el plan de desmontaje con inventario.',
    outcome: 'Llegas al día del evento a supervisar, no a apagar incendios.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d0458bdb-3952-4d7c-b13d-0ca175864779.jpg',
    alt: 'Mockup de la portada vertical del Tomo 3, Logística y Producción, en ciruela profundo con estrella dorada.',
    featured: true,
    featuredLabel: '★ El corazón del sistema',
  },
  {
    number: 'Tomo 4',
    title: 'Marketing y Ventas',
    subtitle:
      'Posicionamiento de alta gama y cierre de contratos high-ticket',
    body: 'Cómo atraer a las familias que sí tienen el presupuesto. El feed editorial que sube tu precio antes de que hables, tu propuesta única de venta, el embudo completo (reel → guía gratuita → cita de diagnóstico), la Presentación Maestra que hace imposible decir que no y el reencuadre exacto para cuando te dicen "es muy caro".',
    outcome:
      'Dejas de competir por precio y empiezas a elegir con qué familia trabajas.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/42a502fb-9c0e-4994-a25a-a065a4446a1a.jpg',
    alt: 'Mockup de la portada vertical del Tomo 4, Marketing y Ventas, en rosa empolvado con líneas doradas.',
  },
  {
    number: 'Tomo 5',
    title: 'Proveedores y Contratos',
    subtitle: 'Dream team, negociación y blindaje legal',
    body: 'Los 3 niveles de proveedores (essential, premium, luxury), el proceso de validación real —seguros, equipos, referencias de otras planners—, el Triángulo de Contratación que te saca de encima la responsabilidad financiera de terceros, las cláusulas que no pueden faltar en tu contrato y el cronograma de pagos que garantiza calidad hasta el último minuto.',
    outcome:
      'Si un proveedor falla, tienes contrato, respaldo y reemplazo. No un problema con tu nombre.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/1fbde026-8044-43b8-9209-2d368db27a40.jpg',
    alt: 'Mockup de la portada vertical del Tomo 5, Proveedores y Contratos, en dorado champagne con tipografía tinta.',
  },
  {
    number: 'Tomo 6',
    title: 'Manual de Crisis y Protocolo',
    subtitle: 'Resolución de imprevistos y etiqueta profesional',
    body: 'El manual de supervivencia para cuando algo se cae: gestión de imprevistos, primeros auxilios del evento, normas de protocolo y etiqueta, y cómo manejar a una familia nerviosa sin perder autoridad.',
    outcome:
      'Cuando todo se complica, eres la única persona tranquila del salón. Eso es exactamente lo que se paga caro.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/773225d3-4b2a-40e5-879c-30bdcb8f79a5.jpg',
    alt: 'Mockup de la portada vertical del Tomo 6, Manual de Crisis y Protocolo, en tinta casi negro con sello dorado.',
  },
]

export const insideEachTomo: string[] = [
  'Frameworks paso a paso',
  'Guiones palabra por palabra',
  'Checklists y plantillas imprimibles',
  'Materiales listos para presentar al cliente',
  'Sistemas universales: cualquier país, cualquier salón, cualquier presupuesto',
]
